import { render, staticRenderFns } from "./ButtonOutline.vue?vue&type=template&id=70ccfbd4&scoped=true&"
import script from "./ButtonOutline.vue?vue&type=script&lang=js&"
export * from "./ButtonOutline.vue?vue&type=script&lang=js&"
import style0 from "./ButtonOutline.vue?vue&type=style&index=0&id=70ccfbd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ccfbd4",
  null
  
)

export default component.exports